import { request } from './client';
import type {
  TokenResponse,
  UserLoginRequest,
  UserRegisterRequest,
  UserResponse,
} from './types';

export function register(payload: UserRegisterRequest) {
  return request<UserResponse>('/open-api/users/register', {
    method: 'POST',
    body: payload,
    auth: false,
  });
}

export function login(payload: UserLoginRequest) {
  return request<TokenResponse>('/open-api/users/login', {
    method: 'POST',
    body: payload,
    auth: false,
  });
}

export function refresh(refreshToken: string) {
  return request<TokenResponse>('/open-api/users/refresh', {
    method: 'GET',
    auth: false,
    headers: { Authorization: refreshToken },
  });
}
